import axios from 'axios';
import user from '../utils/user';

const baseUrl = `${process.env.VUE_APP_API_VIDA_URL}/edi`;

const authHeaders = () => ({
  headers: {
    Authorization: `Bearer ${user.getUserAuthToken()}`,
  },
});

export default {
  async getLogs(params = {}) {
    try {
      const response = await axios.get(baseUrl, {
        ...authHeaders(),
        params,
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async uploadFile(file) {
    try {
      const formData = new FormData();
      formData.append('file', file);

      const response = await axios.post(
        `${baseUrl}/upload`,
        formData,
        authHeaders(),
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  async reinsertInQueue(logId) {
    try {
      const response = await axios.post(
        `${baseUrl}/${logId}/queue`,
        {},
        authHeaders(),
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};
